import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { parseBiDatasetChoiceWidgetPayload } from '@euler/model/bi/widgets';
import { memo } from 'react';
import { DatasetChoiceCard } from './DatasetChoiceCard';

/**
 * The `bi_dataset_choice` fence: the user's datasets that fit the request,
 * by id; picking one continues the conversation with it.
 */
export const BiDatasetChoiceWidget = memo(({ data }: { data: unknown }) => {
  const payload = parseBiDatasetChoiceWidgetPayload(data);
  if (!payload) return <CardNotice text="这个数据选择无效，请重新提问。" />;
  return <DatasetChoiceCard payload={payload} />;
});
